module.exports = __webpack_public_path__ + "static/media/voidcheque.da09585b.webp";